import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'shop',
    serviceName: 'graphql',
    query: gql`
      query shop(
        $ids: [String]
        $title: String
        $alias: String
        $type_ids: [String]
        $is_parent: Int
        $is_active: Int
        $for_admin: Int
        $lat: String
        $lng: String
        $distance: String
        $status_ids: [String]
        $manager_ids: [String]
        $creator_ids: [String]
        $updator_ids: [String]
        $score_ids: [String]
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        shop(
          ids: $ids
          title: $title
          alias: $alias
          type_ids: $type_ids
          is_parent: $is_parent
          is_active: $is_active
          lat: $lat
          lng: $lng
          distance: $distance
          status_ids: $status_ids
          for_admin: $for_admin
          manager_ids: $manager_ids
          creator_ids: $creator_ids
          updator_ids: $updator_ids
          score_ids: $score_ids
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
            status {
              id
            }
            media {
              id
              full_url
              collection_name
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteShop',
    serviceName: 'admin',
    query: gql`
      mutation deleteShop($ids: [String]!) {
        deleteShop(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'shop',
    serviceName: 'graphql',
    query: gql`
      query shop($ids: [String]) {
        shop(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'shop',
    serviceName: 'graphql',
    query: gql`
      query shop($ids: [String]) {
        shop(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
